import { connect } from 'react-redux';
import { IApplicationState } from '../../types/redux';
import { changeTabs } from '../../actions/location';
import { ChildrenComponent } from './children';

export const Children = connect(
  (state: IApplicationState) => ({
    tabs: state.tabs,
  }),
  {
    changeTabs,
  },
)(ChildrenComponent);
